import React, { FC, useMemo } from 'react';
import moment from 'moment';
import { Button, Col, Row } from 'antd';
import { Selector } from 'common/components/Selector/Selector';
import { Calendar, Funnel } from 'common/svg';
import { getWeekOptions } from 'common/helpers/date.helper';

interface IComponentProps {
  year?: number;
  week?: number;
  // Whether the drawer is open or any other page-specific condition (e.g. a store is selected)
  // that should also highlight the funnel button.
  filterActive?: boolean;
  onWeekSelect: (value?: string | number) => void;
  onOpen: () => void;
}

export const PeriodFilterToolbar: FC<IComponentProps> = ({ year, week, filterActive, onWeekSelect, onOpen }) => {
  const resolvedWeek = week ?? moment().isoWeek();
  const weekOptions = useMemo(() => getWeekOptions(year), [year]);
  const isActive = !!filterActive || !!week;

  return (
    <Row gutter={[8, 8]} align="middle">
      <Col>
        <Selector
          suffix={<Calendar />}
          placeholder={
            <>
              <Calendar />
              <span>Select Period</span>
            </>
          }
          options={weekOptions}
          value={resolvedWeek}
          onChange={onWeekSelect}
        />
      </Col>
      <Col>
        <Button
          className={`btn-gray square ${isActive ? 'btn-gray-selected' : ''}`}
          icon={<Funnel className={isActive ? 'icon-purple' : 'icon-gray'} />}
          onClick={onOpen}
        />
      </Col>
    </Row>
  );
};
